module.exports = __webpack_public_path__ + "img/chicaconlaptod.26509c41.png";